/*
 * @Author: chen zhen
 * @Date: 2018-10-23 15:28:01
 * @Last Modified by: Nie Wei
 * @Last Modified time: 2019-11-04 15:37:04
 * @Description: 处理事件的初始化和销毁之前的钩子事件
 */
// import store from '@/store'
// import debounce from '@/assets/js/debounce'

import store from '@/store'

const init = () => {
  // 当出现resize事件的时候  进行执行
  window.onresize = () => {
    store.getters['common/resizeEventSet'].forEach((e) => {
      try {
        e()
      } catch (error) {
        // console.error(error)
      }
    })
  }
}

const destroy = () => {}

export default {
  init, destroy,
}
